'use client'
import Image from 'next/image'
import Marquee from 'react-fast-marquee'
import { Heading } from '@/components/heading'
import React from 'react'

export function Partner() {
  const topLogos = [
    { name: '时尚', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/shishang.png' },
    { name: '腾讯新闻', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/tengxunxinwen.png' },
    { name: '金山办公', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/jinshan.png' },
    { name: '鹏华基金', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/penghua.png' },
    { name: '长江证券', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/changjiang.png' },
    { name: '国家预警发布中心', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/yujing.png' },
    // { name: '字节跳动', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/bytedance.png' },
    { name: '劲牌', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/jinpai.png' }
  ]
  const middleLogos = [
    { name: '云桥网', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/yunqiaowang.png' },
    { name: '人民日报', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/renmingribao.png' },
    { name: '人民网', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/renmingwang.png' },
    { name: '新华社', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/xinhuashe.png' },
    { name: '紫荆', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/zijin.png' },
    { name: '湖北卫视', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/hubeiweishi.png' },
    { name: '人民法院新闻传媒总社', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/renmingfayuan.png' },
    { name: '腾讯公益', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/tengxun.png' },
    { name: '传播大脑', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/chuanbodanao.png' }
  ]
  const bottomLogos = [
    { name: '武汉大学', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/wuhandaxue.png' },
    { name: '华中科技大学', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/huazhongkejidaxue.png' },
    { name: '四川大学', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/sichuandaxue.png' },
    { name: '复旦大学', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/fudandaxue.png' },
    { name: '清华大学', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/qinghuadaxue.png' },
    { name: '中山大学', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/zhongshandaxue.png' },
    { name: '中国人民大学', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/zhongrenmindaxue.png' }
    // { name: 'CICG', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/cicg.png' },
    // { name: 'CCTV', src: 'https://cdn.aitubiao.com/static/images/itubiao/parterners/cctv.png' },
  ]

  const LogoContainer = ({ logo }: { logo: { name: string; src: string } }) => (
    <div className="mx-3 flex h-[85px] min-h-8 w-[187px] flex-shrink-0 items-center justify-center rounded-[32px] border border-white bg-white p-3 shadow-[0px_9.144px_17.145px_3.429px_rgba(141,162,214,0.15)]">
      <Image src={logo.src} alt={logo.name} width="100" height="100" className="max-h-[50px] w-auto object-contain" />
    </div>
  )

  return (
    <div className="mx-auto my-40 w-full max-w-7xl px-4 md:px-8">
      <Heading as="h1" className="relative z-10 mx-auto mt-6 max-w-6xl text-center text-4xl font-bold text-foreground md:text-4xl lg:text-6xl">
        100000+客户共同见证
      </Heading>

      <div className="relative mt-16 overflow-hidden p-10 pt-0">
        {[topLogos, middleLogos, bottomLogos].map((logos, index) => (
          <div key={`logo-row-${index}`} className="relative mt-4">
            <div className="relative">
              <Marquee autoFill style={{ overflow: 'visible' }} pauseOnHover={false} direction={index === 1 ? 'left' : 'right'} speed={20}>
                {logos.map(logo => (
                  <LogoContainer key={logo.name} logo={logo} />
                ))}
              </Marquee>
              <div
                className="pointer-events-none absolute inset-0"
                style={{ background: 'linear-gradient(to right, white, transparent 20%, transparent 80%, white)' }}
              />
            </div>
          </div>
        ))}
        <div className="absolute inset-0 z-10" style={{ background: 'linear-gradient(to right, white, transparent 20%, transparent 80%, white)' }}></div>
      </div>
    </div>
  )
}
